<template>
    <div>
        <!-- <div class="top-wave"></div> -->
        <div class="mt-5 vault-detail">
            <div class="row justify-content-center">
                <div class="col-12 mb-3">
                    <div v-if="vaultStripLoad">
                        <vault-strip
                            v-if="!vault.is_il"
                            :pQueuedDeposits="keyCounter"
                            :pQueuedWithdraws="pQueuedWithdraws"
                            :userInfo="userInfo"
                            :tab="tab"
                            v-on:update-vault="updateVaultInfo"
                            :data="vault"
                        />
                        <ILVaultStrip
                            :pQueuedDeposits="keyCounter"
                            :pQueuedWithdraws="pQueuedWithdraws"
                            :userInfo="userInfo"
                            :tab="tab"
                            v-on:update-vault="updateVaultInfo"
                            :data="vault"
                            v-else
                        />
                    </div>
                    <div
                        v-else
                        style="display: flex;align-items: center;margin-left: 2em; justify-content:center"
                    >
                        <div class="text-green-gradient">
                            Loading...
                        </div>
                        <div>&nbsp;</div>
                        <div
                            style="display: flex;min-width:4em;justify-content: center;align-items: center;position: relative;padding: 2rem 0;overflow: hidden;"
                        >
                            <div class="dot-falling"></div>
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <card class="flex-wrap" customClass="mob-grap">
                        <div class="row w-100 mb-4 no-gutters">
                            <div class="col-12 col-md-6"></div>
                        </div>
                        <div class="row w-100 statistics-block no-gutters">
                            <div class="sts-block-1">
                                <div class="each-container">
                                    <div class="each">
                                        <div class="each-title">
                                            Current
                                            <span
                                                v-if="vault"
                                                style="text-transform: uppercase"
                                                >{{ vault.token }}</span
                                            >
                                            Price
                                        </div>
                                        <div
                                            v-if="vault"
                                            class="each-amount"
                                            id="token-price"
                                        >
                                            {{
                                                formatCurrency(vault.usd_price)
                                            }}
                                        </div>
                                    </div>
                                    <div class="each mobile-text-align-right">
                                        <div class="each-title">
                                            Selected
                                            <span
                                                v-if="vault"
                                                style="text-transform: uppercase"
                                                >{{ vault.token }}</span
                                            >
                                            Strike Price
                                        </div>
                                        <div
                                            v-if="vault != null"
                                            class="each-amount"
                                            id="token-strike-price"
                                        >
                                            {{
                                                formatCurrency(
                                                    +vault.vault_detail
                                                        .strike_price
                                                )
                                            }}
                                        </div>
                                    </div>
                                    <div class="each">
                                        <div class="each-title">
                                            Time to Expiry
                                        </div>
                                        <div class="each-amount" v-if="vault">
                                            <count-down
                                                v-if="vault"
                                                :expiry="
                                                    vault.vault_detail.expiry
                                                "
                                                id="expiry-time"
                                                :vault="vault"
                                            />
                                        </div>
                                    </div>
                                    <div class="each mobile-text-align-right">
                                        <div class="each-title">
                                            Time Period
                                        </div>
                                        <div
                                            style="text-transform: capitalize;"
                                            class="each-amount"
                                            v-if="vault"
                                            id="time-period"
                                        >
                                            {{ vault.time_period }}
                                        </div>
                                    </div>
                                    <!-- <div class="each">
                                        <div class="each-title">
                                            This Week's Performance
                                        </div>
                                        <div class="each-amount">
                                            0.70%
                                        </div>
                                    </div> -->
                                </div>
                                <div
                                    v-if="vault"
                                    class="row mt-mob desc-deposit"
                                >
                                    <div
                                        class="col-6 font-weight-bold"
                                        style="text-transform: uppercase"
                                    >
                                        <!--Deposits: {{ (vault.vault_detail)? (+vault.vault_detail.total_deposit + (+vault.total_exit)):0 }} {{ vault.token }}-->
                                        Deposits:
                                        <span id="deposit-detail">
                                            {{ depositAmount }}
                                            {{ vault.real_token_symbol }}
                                        </span>
                                    </div>
                                    <div
                                        class="col-6 font-weight-bold text-right"
                                        style="text-transform: uppercase"
                                    >
                                        Max
                                        <span id="max-deposit">{{
                                            moneyFormat(maxDeposits)
                                        }}</span>
                                        {{ vault.real_token_symbol }}
                                    </div>
                                </div>
                                <div
                                    v-if="vaultLoaded"
                                    class="statistics-progress mt-3 mb-2"
                                >
                                    <div
                                        style="--series-color: linear-gradient(208.27deg,#6ee29f 0%,#27ae60 95.3%); --series-width: 25%;"
                                        class="series"
                                        :style="ownDepositWidth"
                                    ></div>
                                    <div
                                        style="--series-color: linear-gradient(208.27deg,#278eff 0%,#6271ff 95.3%); --series-width: 25%;"
                                        class="series"
                                        :style="totalDepositWidth"
                                    ></div>
                                </div>
                                <div class="mt-3">
                                    <div
                                        v-if="vaultLoaded"
                                        class="row desc-your-deposit"
                                    >
                                        <div
                                            class="col-6 font-weight-bold text-green-gradient"
                                        >
                                            Your Deposits:
                                            <span id="your-deposit">{{
                                                calcYourDeposit
                                            }}</span>
                                            <span
                                                style="text-transform: uppercase"
                                                >{{
                                                    vault.real_token_symbol
                                                }}</span
                                            >
                                        </div>
                                        <div
                                            class="col-6 font-weight-bold text-right text-green-gradient"
                                        >
                                            Owned:
                                            <span id="owned">{{
                                                myOwned
                                            }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="desc-box mb-4" v-if="vault">
                            <div class="hr w-100 mt-2 mb-2 hr-mob"></div>
                            <div class="w-100 d-flex justify-content-between">
                                <div class="card-table-title pt-1">
                                    Vault Strategy
                                </div>
                            </div>
                            <div class="row mt-1">
                                <div
                                    class="col-12 mb-2"
                                    v-html="vault.strategy"
                                ></div>
                            </div>
                            <div class="hr w-100 mt-2 mb-2 hr-mob"></div>
                            <div class="row">
                                <div class="col-12 col-md-6 mb-2">
                                    <div
                                        class="w-100 d-flex justify-content-between"
                                    >
                                        <div class="card-table-title pt-1">
                                            withdrawals
                                        </div>
                                    </div>
                                    <div v-html="vault.withdrawals"></div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div
                                        class="w-100 d-flex justify-content-between"
                                    >
                                        <div class="card-table-title pt-1">
                                            risk
                                        </div>
                                    </div>
                                    <div v-html="vault.risk"></div>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
                <div class="col-12 mb-5">
                    <card class="flex-wrap" customClass="mob-grap">
                        <vault-activity v-if="vault" :vault="vault" />
                    </card>
                </div>
            </div>
        </div>
        <!-- <div class="bottom-leafs"></div> -->
    </div>
</template>

<script>
import Pagination from "vue-pagination-2";
import VaultStrip from "../components/VaultStrip";
import Card from "../components/Card";
import { createChart, isBusinessDay, LineStyle } from "lightweight-charts";
import ILVaultStrip from "../components/IL/ILVaultStrip";

import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import moment from "moment";

import Graph from "../components/Graph";

import VaultActivity from "../components/VaultActivity";

export default {
    components: {
        VaultStrip,
        Card,
        Pagination,
        Graph,
        VaultActivity,
        ILVaultStrip
    },
    data() {
        return {
            vault: null,
            vaultLoaded: false,
            myPosition: 0,
            myOwned: 0,
            page: 1,
            keyCounter: 0,
            pQueuedWithdraws: 0,
            marketYeld: [],
            userInfo: {},
            tab: null,
            transactionHistory: [],
            columns: ["action", "contract", "quantity", "yield"],
            tableData: [
                { id: 1, name: "John", age: "20" },
                { id: 1, name: "John", age: "20" },
                { id: 1, name: "John", age: "20" }
            ],
            options: {
                // see the options API
            },
            currBalance: 0
        };
    },
    methods: {
        ...mapActions({
            setData: "il/setData",
            getAllVaults: "vaults/getAllVaults"
            // connectWithMetamask: "wallet/connectWithMetamask"
        }),
        moment,
        async init() {
            let tempChainId = null;
            // if connected read chainId from state
            if (this.walletProvider && this.chainId) {
                tempChainId = this.chainId;
            } else if (this.$route.params.chainId) {
                // if not connected then read route param
                tempChainId = this.$route.params.chainId;
            } else {
                tempChainId = "all";
            }

            if (tempChainId) {
                const getCurrentVault = await axios.get(
                    `/api/all-vaults/${this.$route.params.id}/${tempChainId}`
                );

                this.vault = getCurrentVault.data;
                this.updateVaultInfo();
            }
        },
        formatCurrency(val) {
            const formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            return formatter.format(val);
        },
        getVaultPosition() {
            //
            if (
                this.vault.vault_detail.epoch > this.userInfo.queuedEpoch &&
                this.userInfo.queuedEpoch != 0
            ) {
                return this.userInfo.queuedDeposits;
            } else if (
                this.vault.vault_detail.epoch == this.userInfo.queuedEpoch
            ) {
                return this.userInfo.queuedDeposits;
            } else if (
                this.userInfo.queuedEpoch == 0 &&
                this.userInfo.position > 0
            ) {
                return this.userInfo.position;
            } else {
                return 0;
            }
        },
        getMarketYealds() {
            axios
                .get(`/api/get_apy`)
                .then(res => {
                    //this.vaults.vaults.sort((a, b) => b.apy - a.apy)
                    this.marketYeld = res.data.sort((a, b) => b.rate - a.rate);
                })
                .catch(err => {});
        },
        getTransactionHistory() {
            axios
                .get(`/api/vaults/${this.vault.id}/transaction-history`)
                .then(res => {
                    //this.marketYeld = res.data.sort((a, b) => b.rate - a.rate);
                    //
                    this.transactionHistory = res.data.data;
                })
                .catch(err => {});
        },
        getRoundGraph() {
            axios
                .get(`/api/roundHistory/${this.$route.params.id}`)
                .then(res => {
                    //this.marketYeld = res.data.sort((a, b) => b.rate - a.rate);
                    //
                })
                .catch(err => {});
        },
        ...mapMutations(["setSelectedToken"]),
        async updateVaultInfo() {
            if (this.vault) {
                let token = this.wallet.tokens.find(
                    item =>
                        item.symbol == this.vault.real_token_symbol &&
                        item.network == this.vault.network
                );
                if (token == undefined) return;

                //set selectedToken
                this.$store.commit("wallet/setSelectedToken", {
                    token: token.symbol,
                    network: token.network
                });

                let vaultInfoData = await this.$store.dispatch(
                    "vaults/getVaultInfo",
                    {
                        vault_address: this.$route.params.id,
                        symbol: token.symbol,
                        vault_network: this.vault.network
                    }
                );

                let myPositionData = await this.$store.dispatch(
                    "vaults/getMyPosition",
                    {
                        vault: this.vault,
                        decimals: token.decimals
                    }
                );

                //
                this.userInfo = myPositionData;
                Object.assign(this.vault, vaultInfoData);
                //this.vault = {...this.vault,...vaultInfoData};

                this.vault.queuedEpoch = myPositionData.queuedEpoch;
                this.vault.exitQueueEpoch = myPositionData.exitQueueEpoch;
                this.vault.queuedDeposits = myPositionData.queuedDeposits;

                // var cdate =moment(this.vault.time_on_expiry * 1000, 'YYYY-MM-DD HH:mm').toDate();

                // var countDownDate = new Date(
                //     cdate
                // );
                var offset = new Date().getTimezoneOffset();
                const date = moment
                    .utc(+this.vault.time_on_expiry * 1000)
                    .format("YYYY-MM-DD HH:mm");

                this.vault.time_on_expiry_calc = date;
                //this.vault.time_on_expiry_calc = moment.utc(this.vault.time_on_expiry * 1000).format('YYYY-MM-DD HH:mm');

                // get token's current deposits in the vault
                this.currBalance = await this.$store.dispatch(
                    "vaults/getVaultCurrentDeposit",
                    {
                        vault_contract: this.vault.contract_address,
                        token: token,
                        vault: this.vault
                    }
                );

                //get token balance after transaction
                await this.$store.dispatch("wallet/getTokenBalance");
                await this.$store.dispatch("wallet/loadAccount", this.chainId);

                this.myPosition = this.getVaultPosition();
                this.myOwned = "0%";
                this.vault.myPosition = this.myPosition;
                this.vault.position = this.myPosition;

                if (this.currBalance && this.currBalance > 0) {
                    this.myOwned =
                        parseFloat(
                            (
                                ((+this.userInfo.deposit / token.decimals) *
                                    100) /
                                this.currBalance
                            ).toFixed(2)
                        ) + "%";
                }
                // if (
                //     +this.vault.vault_detail.epoch >= myPositionData.queuedEpoch
                // ) {
                //     this.keyCounter = 0;
                // } else {
                //     }
                this.keyCounter = myPositionData.queuedDeposits;

                if (myPositionData.exitQueueEpoch > 0) {
                    this.pQueuedWithdraws = myPositionData.queuedWithdraw;
                } else {
                    this.pQueuedWithdraws = 0;
                }

                this.vault.exitToken = myPositionData.exitToken;
            } else {
                this.userInfo = {
                    queuedDeposits: 0,
                    position: 0,
                    activeDeposit: "0",
                    queuedWithdraw: 0,
                    userScaleX1e36: 0,
                    queuedEpoch: 0,
                    exitQueueEpoch: 0,
                    balance: 0,
                    deposit: 0,
                    depositString: "0",
                    exitToken: 0,
                    maxWithdraw: 0,
                    premiumRealised: 0,
                    totalBalance: 0,
                    pendingWithdrawal: 0
                };
                this.myPosition = 0;
                this.myOwned = "0%";
                this.pQueuedWithdraws = 0;
                this.keyCounter = 0;

                if (this.vault) {
                    this.vault.myPosition = 0;
                    this.vault.position = 0;
                }
            }
            this.tab = localStorage.tabState;
            this.$nextTick(() => {
                this.setData({
                    key: "toogleUpdatedVault",
                    value: !this.toogleUpdatedVault
                });
                this.vaultLoaded = true;
            });
        },
        defaultInfo() {
            this.myPosition = 0;
            this.myOwned = "0%";
            this.pQueuedWithdraws = 0;
            this.keyCounter = 0;

            if (this.vault) {
                this.vault.myPosition = 0;
                this.vault.position = 0;
            }
            this.$nextTick(() => {
                this.setData({
                    key: "toogleUpdatedVault",
                    value: !this.toogleUpdatedVault
                });
                this.vaultLoaded = true;
            });
        }
    },
    computed: {
        ...mapState("il", ["toogleUpdatedVault"]),
        ...mapGetters({
            chainId: "wallet/getChainId",
            hasWallet: "wallet/getHasWallet",
            address: "wallet/getAddress",
            walletProvider: "wallet/getWalletProvider"
        }),
        vaultStripLoad() {
            if (this.walletProvider) {
                return this.vault !== null && this.vaultLoaded;
            }

            return this.vault !== null;
        },
        calcYourDeposit() {
            const decimal = this.vault.type == "put_selling" ? 2 : 6;

            let token = this.wallet.tokens.find(
                item =>
                    item.symbol == this.vault.real_token_symbol &&
                    item.network == this.vault.network
            );

            const tokenBalance = this.userInfo.totalBalance;

            if (tokenBalance != 0)
                return this.moneyFormat(tokenBalance, decimal);
            else return this.moneyFormat(tokenBalance);
        },
        ...mapState(["vaults", "wallet"]),

        isContract() {
            return this.$store.vaults.web3;
        },
        maxDeposits() {
            if (this.vault == null) return 0;
            // return this.vault.max_deposit.toLocaleString();
            // return this.vault.max_deposit.toFixed(2);
            return this.vault.max_deposit;
        },
        totalDepositWidth() {
            if (this.vault == null) return "width: 0%;";
            const myPosition = this.userInfo.position ?? 0;
            let width =
                ((+this.currBalance - myPosition) * 100) /
                +this.vault.max_deposit;

            return "width:" + width + "%;";
        },
        ownDepositWidth() {
            if (this.vault == null) return "width: 0%;";
            const myPosition = this.userInfo.position ?? 0;
            let width = parseFloat(
                (myPosition * 100) / +this.vault.max_deposit
            );

            return "width:" + width + "%;";
        },
        getExpiry() {
            if (this.vault.time_on_expiry == null) return "---";
            return moment().to(+(this.vault.time_on_expiry + "000"));
        },
        depositAmount() {
            if (this.vault.vault_detail) {
                if (this.currBalance > this.vault.max_deposit) {
                    return this.moneyFormat(+this.vault.max_deposit);
                } else {
                    return this.moneyFormat(+this.currBalance);
                }
            } else {
                return 0;
            }
        }
    },
    watch: {
        chainId(newChainId, oldChainId) {
            if (
                this.$route.name == "vault_detail" &&
                oldChainId != null &&
                newChainId != oldChainId
            ) {
                this.$router.push("/basic/vaults");
                return;
            }
            this.init();
        },
        vault(nv, ol) {
            // this.updateVaultInfo();
        }
    },
    async mounted() {
        this.init();
        localStorage.tabState = "DEPOSIT";
        // if (!this.hasWallet) await this.connectWithMetamask();
    }
};
</script>
<style lang="scss">
//@import "./resources/sass/_variables.scss";

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
/* Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}

.mobile-text-align-right {
    text-align: right;

    @media only screen and (min-width: 768px) {
        text-align: initial;
    }
}

.legent-chart {
    font-family: Exo;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #ffffff;
    position: absolute;
    right: 8%;
    top: 93%;
    z-index: 1;
    transform: translate(-50%, -50px);
    .line-size {
        vertical-align: top;
        margin-right: 5px;
    }
}
.legendku {
    position: absolute;
    left: 12px;
    top: 12px;
    z-index: 1;
    font-size: 12px;
    line-height: 18px;
    font-weight: 300;
    background: red;
}
.tooltip-charts {
    width: 89.72px;
    height: 22.2px;
    position: absolute;
    display: none;
    box-sizing: border-box;
    font-family: Exo;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    color: #ffffff;
    background-color: #000000;
    text-align: center;
    z-index: 1000;
    top: 12px;
    left: 12px;
    //padding: 4.625px 9.25px;
    mix-blend-mode: lighten;
    border: 2px solid #ffffff;
    border-radius: 10px;
}

.vault-detail {
    width: 77.084vw !important;
    margin: 0 auto;
    .mob-grap {
        z-index: 1;
    }
    .VuePagination__count {
        display: none;
    }
    .card-table-title {
        font-family: Bungee;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16.8px;
        letter-spacing: 0.04em;
        text-transform: capitalize;
        color: var(--primary-4);

        @media only screen and (min-width: 992px) {
            font-size: 1.1111111111111112vw;
            line-height: 1.6666666666666667vw;
        }
    }
    .filter-box {
        display: flex;
    }
    .table-td-title {
        font-family: Exo;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 21px;
        color: var(--primary-4);

        @media only screen and (min-width: 1440px) {
            font-size: 1.1111111111111112vw;
            line-height: 1.476388888888889vw;

            & ~ div {
                font-size: 0.8333333333333334vw;
                line-height: 1.1076388888888888vw;
            }
        }
    }
    .statistics-block {
        display: flex;
        justify-content: space-between;
        margin-bottom: 1.1111111111111112vw;

        .sts-block-1 {
            width: 100%;
            padding-right: 0;
        }
        .sts-block-1 ~ div.description-market-apy {
            width: 100%;
        }
        .each-container {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            .each {
                flex: 0 0 50%;
                max-width: 50%;
                margin-bottom: 14px;
            }
        }

        @media only screen and (min-width: 992px) {
            .sts-block-1 {
                //width: 65.854%;
                //padding-top: 20px;

                .desc-deposit {
                    font-size: 0.8333333333333334vw;
                    margin-top: 2.5694444444444446vw;
                }
                .desc-your-deposit {
                    font-size: 0.9722222222222222vw;
                }
            }
            .sts-block-1 ~ div.description-market-apy {
                width: 30.394%;
            }
            .each-container {
                .each {
                    flex: auto 0 1;
                    max-width: none;
                    margin-bottom: 0;
                }
            }
        }

        .each-title {
            margin-bottom: 5px;
            font-weight: bold;
            font-size: 11.1px;
            line-height: 16.65px;
            color: var(--primary-4);

            @media only screen and (min-width: 992px) {
                font-size: 0.7708333333333334vw;
                line-height: 1.1562499999999998vw;
            }
        }
        .each-amount {
            font-weight: bold;
            font-size: 16.65px;
            line-height: 16.65px;
            color: var(--primary-4);

            @media only screen and (min-width: 992px) {
                font-size: 1.1562499999999998vw;
                line-height: 1.1562499999999998vw;
            }
        }
        .statistics-progress {
            width: 100%;
            display: flex;
            height: 7px;
            mix-blend-mode: lighten;
            border-radius: 1.85px;
            background: rgba(255, 255, 255, 0.3);
            .series {
                background: var(--series-color);
                //width: 20%;
                border-radius: 1.85px;
            }
        }
    }
    .market-title {
        font-weight: 600;
        font-size: 1.1111111111111112vw;
        line-height: 1.476388888888889vw;
        letter-spacing: 0.04em;
        text-transform: capitalize;
        color: var(--primary-4);
        margin-bottom: 14px;

        & ~ div.row {
            margin-bottom: 13px;
        }
    }
    .market-percent {
        font-weight: 600;
        font-size: 1.1111111111111112vw;
        line-height: 1.476388888888889vw;
        text-align: right;

        color: var(--primary-4);
    }
}
.table-desk {
    width: 100%;
}
.table-mob,
.VuePagination__pagination-item-last-page,
.VuePagination__pagination-item-first-page {
    display: none;
}

.tbl-ttl-mob {
    margin-top: 10px;
    margin-bottom: 12px;

    @media only screen and (max-width: 425px) {
        width: 100% !important;
    }
}

@media only screen and (min-width: 0px) and (max-width: 768px) {
    .vault-detail {
        width: 100% !important;
        margin: 0 auto;
        padding: 20px;
        margin-top: 1rem !important;
    }
    .mob-grap {
        padding: 0 12.5px !important;
    }
    .mt-mob {
        margin-top: 22px !important;
    }
    .hr-mob {
        display: none;
    }
    .table-desk {
        display: none;
    }
    .table-mob {
        display: block !important;
        width: 100%;
        .tbl-item {
            font-size: 10px;
            line-height: 13px;
            padding: 0 0 15.5px;
            border-bottom: 0.5px solid rgba(255, 255, 255, 0.25);
            margin-bottom: 14px;
            .ttl-head {
                font-weight: 500;
                color: #cecece;
            }
            .sub-head {
                font-weight: bold;
                font-size: 12px;
                line-height: 16px;
            }
        }
        .btn-vm {
            font-size: 14px !important;
            width: 100% !important;
        }
    }
}

.desc-box {
    .hr {
        margin: 0.5555555555555556vw 0;
    }
    .hr ~ div.w-100.d-flex,
    .hr ~ .row div.w-100.d-flex {
        margin: 1.1111111111111112vw 0;
    }
    p {
        font-size: 12px;
        line-height: 16px;

        @media only screen and (min-width: 1440px) {
            /* font-size: calc(10px + 0.13889vw); */
            font-size: 0.8333333333333334vw;
            /* font-size: calc(7.56px + 0.30833vw); */
            line-height: 1.1111111111111112vw;
            margin-bottom: calc(4px + 0.7411vw);
        }
    }

    @media only screen and (min-width: 1440px) {
        .row > div {
            padding-left: calc(9px + 0.243vw);
            padding-right: calc(9px + 0.243vw);
        }
    }
}

#dropdownActivityButton,
#dropdownSortButton {
    font-size: 10px;

    ~ div[aria-labelledby="dropdownActivityButton"] a,
    ~ div[aria-labelledby="dropdownSortButton"] a {
        font-size: calc(10px + 0.3vw);

        @media only screen and (min-width: 1440px) {
            font-size: 14px;
        }
    }

    @media only screen and (min-width: 768px) {
        font-size: calc(9px + 0.3vw);
    }

    @media only screen and (min-width: 1440px) {
        font-size: 0.9027777777777778vw;
    }
}
</style>
